
import { Component, Vue } from "vue-property-decorator";
import OpenInvoiceMatchingComponent from "@/views/Accounting/OpenInvoiceMatchingComponent.vue";
import OpenMahnungen from "@/views/Accounting/OpenMahnungen.vue";
import AllInvoices from "@/views/Accounting/AllInvoices.vue";
import Payments from "@/views/Accounting/Payments.vue";
@Component({
	components: {
		OpenInvoiceMatchingComponent,
		OpenMahnungen,
		AllInvoices,
		Payments,
	},
})
export default class AccountingDashboard extends Vue {
	private reloadMahnungenToggle: boolean = false;
	private allInvoicesListHasMoreToLoad: boolean = true;
	private allInvoicesIsLoading: boolean = false;
	private loadMoreInvoicesToggle: boolean = false;
	private paymentsIsLoading: boolean = false;
	private paymentsInvoiceIdFilter: number = 0;
	private tabs = [
		{ id: 0, text: "paymentMatching", visibleText: "Zahlungsabgleich Bank" },
		{ id: 1, text: "allInvoices", visibleText: "Rechnungen" },
		{ id: 2, text: "payments", visibleText: "Zahlungen" },
		{ id: 3, text: "mahnungen", visibleText: "Mahnungen" },
	];

	beforeRouteEnter(to: any, from: any, next: any) {
		next((vm: any) => {
			window.addEventListener("scroll", vm.checkBottom);
		});
	}

	beforeRouteLeave(to: any, from: any, next: any) {
		window.removeEventListener("scroll", this.checkBottom);
		next();
	}

	private get activeTab(): number {
		return this.$store.state.activeAccountingTab;
	}
	private set activeTab(tab: number) {
		this.$store.commit("setActiveAccountingTab", tab);
	}

	private reloadMahnungen() {
		this.reloadMahnungenToggle = true;
	}

	private setAllInvoicesListHasMoreToLoad(state: boolean) {
		this.allInvoicesListHasMoreToLoad = state;
	}

	private setAllInvoicesIsLoading(state: boolean) {
		this.allInvoicesIsLoading = state;
	}

	private setPaymentsIsLoading(state: boolean) {
		this.paymentsIsLoading = state;
	}

	private navigateToPayments(invoiceId: number) {
		this.activeTab = this.getKeyFromText("payments");
		this.paymentsInvoiceIdFilter = invoiceId;
	}

	private checkBottom() {
		let bottomOfWindow =
			window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (bottomOfWindow && this.allInvoicesListHasMoreToLoad && !this.allInvoicesIsLoading) {
			if (this.activeTab === this.getKeyFromText("allInvoices")) {
				this.loadMoreInvoicesToggle = true;
			}
		}
	}

	private getKeyFromText(text: string) {
		return this.tabs.filter((tab: any) => tab.text === text)[0].id;
	}
}
